import {localEnvironment} from '../../config/localEnvironment';
import {devEnvironment} from '../../config/devEnvironment';
import {qaEnvironment} from '../../config/qaEnvironment';
import {prodEnvironment} from "../../config/prodEnvironment";

function getQAEnvironment(url) {
  let clientEnvironment;
  if (
      url.includes('wwwqa.postprequalify.ford.com') ||
      url.includes('wwwqa.prequalify.ford.com') ||
      url.includes('wwwqa.qualify.ford.com') ||
      url.includes('expressrateclient-jfzq4jkplq-uc.a.run.app') ||
      url.includes('wwwuat.qualify.ford.com')
  ) {
    clientEnvironment = qaEnvironment('USA');
  }

  if (
    url.includes('wwwqa.prequalify.ford.ca') ||
    url.includes('wwwqa.postprequalify.ford.ca')
  ) {
    clientEnvironment = qaEnvironment('CAN');
  }

  if (
    url.includes('wwwqa.ford.com')
  ) {
    clientEnvironment = qaEnvironment('USA', true);
  }
  if (
    url.includes('wwwqa.ford.ca') ||
      url.includes('frqa.ford.ca') ||
      url.includes('frqa2.ford.ca')
  ) {
    clientEnvironment = qaEnvironment('CAN', true);
  }
  return clientEnvironment;
}

function getDevEnvironment (url) {
  let clientEnvironment;
  if (
    url.includes('expressrateclient-sioggypyrq-uc.a.run.app') ||
    url.includes('expressrateclient-dev-sioggypyrq-uc.a.run.app') ||
    url.includes('wwwdev.prequalify.ford.com') ||
      url.includes('wwwdev.postprequalify.ford.com')
  ){
    clientEnvironment = devEnvironment('USA');
  }

  if (
    url.includes('wwwdev.prequalifyca.ford.com') ||
      url.includes('wwwdev.postprequalifyca.ford.com')
  ){
    clientEnvironment = devEnvironment('CAN');
  }
  return clientEnvironment;
}

function getProdEnvironment (url) {
  let clientEnvironment;
  if (
    url.includes('apps.pd01e.uscentral1.cf.gcp.ford.com') ||
    url.includes('apps.pd02e.uscentral1.cf.gcp.ford.com') ||
    url.includes('www.prequalify.ford.com') ||
    url.includes('www.qualify.ford.com') ||
    url.includes('expressrateclient-cj2l4gu6mq-uc.a.run.app') ||
    url.includes('www-prequalify.cf.app.ford.com') ||
      url.includes('www.postprequalify.ford.com')
  ) {
    clientEnvironment = prodEnvironment('USA');
  }

  if (url.includes('www.ford.com')) {
    clientEnvironment = prodEnvironment('USA', true);
  }
  if (url.includes('www.prequalify.ford.ca')) {
    clientEnvironment = prodEnvironment('CAN');
  }

  if(url.includes('www.ford.ca')) {
    clientEnvironment = prodEnvironment('CAN', true);
  }
  return clientEnvironment;
}
function getLocalEnvironment (url) {
  let clientEnvironment;
  clientEnvironment = localEnvironment('USA');
  if(url.includes('localhost:3005') || url.includes('localhost:3007')){
    clientEnvironment = localEnvironment('CAN');
  }
  return clientEnvironment;
}

const loadConfig = (url) => {
  let loadEnvironment = getQAEnvironment(url);
 if(!loadEnvironment) {
   loadEnvironment = getDevEnvironment(url);
 }
  if(!loadEnvironment) {
    loadEnvironment = getProdEnvironment(url);
  }
  if(!loadEnvironment) {
    loadEnvironment = getLocalEnvironment(url);
  }
  return loadEnvironment;

};


export default loadConfig;
